import { hellopanda_func as $ } from '../../assets/script/func.js';

const themeModule = {
  init: function() {
    const _ = this;
    _.theme_toggle();
    _.toggle_block();
    // _.hover_box_color(); 서버사이드로 옮김
    document.addEventListener("DOMContentLoaded", (event) => {
      _.effect_link();
      _.parallax_background();
      _.noCss();
    });
    window.addEventListener("load", function (event) {
      _.popup_setting();
    });
  },
  noCss: function() {

    /**
     * 모든 트랜젝션을 활성화
     */
    setTimeout(() => {
      const noTransitionStyle = document.getElementById('hellopanda-theme-expand-no-css');
      if (noTransitionStyle) {
        noTransitionStyle.remove();
      }
    }, 300);

  },
  isCookieEnabled: function() {
    // 테스트용 쿠키 설정
    document.cookie = "testcookie=test; path=/";
    
    // 쿠키가 저장되는지 확인
    const isEnabled = document.cookie.indexOf("testcookie=") !== -1;
    
    // 테스트용 쿠키 삭제
    document.cookie = "testcookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    
    return isEnabled;
  },
  isLocalStorageEnabled: function() {
    try {
      // 테스트용 데이터 저장
      localStorage.setItem("testLocalStorage", "test");
  
      // 저장한 데이터 읽기
      const isEnabled = localStorage.getItem("testLocalStorage") === "test";
  
      // 테스트용 데이터 삭제
      localStorage.removeItem("testLocalStorage");
  
      return isEnabled;
    } catch (e) {
      // 로컬 스토리지가 차단되었거나 오류 발생 시 false 반환
      return false;
    }
  },
  setCookie: function(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },
  getCookie: function(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  setStorage: function(name, value, days) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (days * 24 * 60 * 60 * 1000));
    
    const item = {
      value: value,
      expires: expirationDate.getTime() // 만료 시간을 타임스탬프로 저장
    };
    
    localStorage.setItem(name, JSON.stringify(item));
  },
  getStorage: function(name) {
    const itemStr = localStorage.getItem(name);
    
    if (!itemStr) {
      return null; // 값이 없으면 null 반환
    }
  
    const item = JSON.parse(itemStr);
    const currentTime = new Date().getTime();
    
    // 만료된 항목은 로컬 스토리지에서 삭제하고 null 반환
    if (currentTime > item.expires) {
      localStorage.removeItem(name);
      return null;
    }
  
    return item.value;
  },
  theme_toggle: function() {

    // 초기 설정
    const savedMode = getCookie('themeMode') || 'light';
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const currentMode = savedMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : savedMode;
    document.documentElement.setAttribute('data-theme-mode', currentMode);

    const btns = document.querySelectorAll('.theme-toggle-btn');
    btns.forEach(btn => {

      btn.addEventListener('click', () => {

        // 애니메이션 등록
        document.body.classList.add('theme-animation');
        setTimeout(() => {
          document.body.classList.remove('theme-animation');
        }, 300);

        // 테마 변경
        const savedMode = getCookie('themeMode') || 'light';
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const currentMode = savedMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : savedMode;

        // 최종 테마 모드
        let newMode = currentMode === 'light' ? 'dark' : 'light';

        // 만약 아이프레임 속에 있다면 html 상태만 체크하자.
        if (window.self !== window.top) {
          const htmlTheme = document.querySelector('html')?.getAttribute('data-theme-mode') === 'light' ? 'dark' : 'light' ;
          newMode = htmlTheme; // 최종 테마모드 변경
        }

        // 쿠키 설정 함수 호출
        setCookie('themeMode', newMode, 365);
        document.documentElement.setAttribute('data-theme-mode', newMode);
        
      });

    });

    // 쿠키 값을 가져오는 함수
    function getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
          return cookie.substring(name.length + 1);
        }
      }
      return null;
    }

    // 쿠키 값을 설정하는 함수
    function setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

  },
  toggle_block: function() {

    // 모든 열려 있는 토글을 닫는 함수
    function close_all_toggle() {
      const opened_containers = document.querySelectorAll('.wp-block-hellopanda-toggle-block.toggle-active');
      opened_containers.forEach((opened_container) => {
        opened_container.classList.remove('toggle-active');
      });
    }

    // 클릭 이벤트 핸들러 함수
    function handleClick(event) {
      // 클릭한 요소가 '.wp-block-hellopanda-toggle-block.toggle-action-click' 내부에 있는지 확인
      const container = event.target.closest('.wp-block-hellopanda-toggle-block.toggle-action-click');
      if (container) {
        // 요소가 활성화되지 않은 경우 활성화
        if (!container.classList.contains('toggle-active')) {
          container.classList.add('toggle-active');
        } else {
          // 요소가 활성화된 경우, 닫기 버튼을 클릭한 것인지 확인
          const container_closebtn = event.target.closest('.hellopanda-toggle-block-overlay-close');
          if (container_closebtn) {
            container.classList.remove('toggle-active');
          }
        }
      } else {
        // 컨테이너가 없으면 모든 토글을 닫음
        close_all_toggle();
      }
    }

    // ESC 키를 눌렀을 때 모든 토글을 닫는 이벤트 핸들러
    function handleKeydown(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        close_all_toggle();
      }
    }

    // 이벤트 리스너 등록
    document.addEventListener("click", handleClick);
    document.addEventListener("keydown", handleKeydown);

  },
  hover_box_color: function() {

    const boxContainers = document.querySelectorAll('.box-color-effect');
    boxContainers.forEach(box => {
      if (box.dataset.boxHovertext || box.dataset.boxHoverbg || box.dataset.boxHoverborder) {
        const style = document.createElement('style');
        const activeClass = $.randomOnlyString(20);
        style.innerHTML += `
          .${activeClass}:hover {
            ${box.dataset.boxHovertext ? `color: ${box.dataset.boxHovertext} !important;` : ''}
            ${box.dataset.boxHoverbg ? `background-color: ${box.dataset.boxHoverbg} !important;` : ''}
            ${box.dataset.boxHoverborder ? `border-color: ${box.dataset.boxHoverborder} !important;` : ''}
          }
        `;
        style.innerHTML = style.innerHTML.replace(/\s+/g, ' ').trim();
        box.classList.add(activeClass);
        box.appendChild(style);
      }
    });

  },
  popup_setting: function() {
    
    const _ = this;

    const enabledCookie = _.isCookieEnabled();
    const enabledStorage = _.isLocalStorageEnabled();

    if (!enabledCookie && !enabledStorage) {
      console.error('팝업창 기능 동작에 필요한 쿠키, 스토리지가 차단되어 있습니다. 브라우저 설정을 확인해주세요.');
      return;
    }

    // 쿠키로 닫기
    function closePopup(popupElement) {
      const dateValue = popupElement.dataset.date;
      const key = 'hellopanda-popup-' + popupElement.dataset.key +'-'+ popupElement.dataset.code;
  
      let days = 0; // 기본값은 반복
      if (dateValue === '1day') {
          days = 1;
      } else if (dateValue === '3day') {
          days = 3;
      } else if (dateValue === '1week') {
          days = 7;
      } else if (dateValue === 'forever') {
          days = 365 * 10; // 영구적으로 닫기 위해 10년 설정
      }
  
      if (enabledCookie) {
        _.setCookie(key, 'closed', days); // 팝업 상태를 쿠키에 저장
      } else if (enabledStorage) {
        _.setStorage(key, 'closed', days); // 팝업 상태를 스토리지에 저장
      }

      // 나중에 보여줄려고 했었나? 
      popupElement.classList.add('closed');
      // popupElement.style.display = 'none'; // 팝업 숨기기

      // 팝업창 제거
      // popupElement.remove();
    }

    // 지정해서 닫기
    function closePopupInTarget(popup) {

      // 생성된 암막 지우기
      const popupBack = popup.nextElementSibling;
      if (popupBack) {
        if (popupBack.classList.contains('wp-block-hellopanda-popup-block-back')) {
          popupBack.remove();
        }
      }

      // 팝업 지우기
      popup.remove();

    }

    // 상단 팝업부터 먼저 닫기
    function closePopupInOrder() {

      // const popups = Array.from(document.querySelectorAll('.wp-block-hellopanda-popup-block[status="ready"]'));
      const popups = Array.from(
        document.querySelectorAll('.wp-block-hellopanda-popup-block[status="ready"]')
      ).filter(el => {
        let current = el;
        while (current) {
          if (getComputedStyle(current).display === 'none') {
            return false; // 숨겨진 요소는 제외
          }
          current = current.parentElement;
        }
        return true;
      });

      if (popups.length > 0) {
        const topPopup = popups.reduce((maxPopup, popup) => {
          const zIndex = parseInt(getComputedStyle(popup).zIndex, 10) || 0;
          const maxZIndex = parseInt(getComputedStyle(maxPopup).zIndex, 10) || 0;
  
          // z-index가 크거나, 같다면 배열에서 뒤쪽(나중에 생성된 것) 요소를 선택
          return zIndex > maxZIndex || (zIndex === maxZIndex && popups.indexOf(popup) > popups.indexOf(maxPopup))
            ? popup
            : maxPopup;
        }, popups[0]); // 첫 번째 요소를 기본값으로 설정
  
        // 생성된 암막 지우기
        const topPopupBack = topPopup.nextElementSibling;
        if (topPopupBack) {
          if (topPopupBack.classList.contains('wp-block-hellopanda-popup-block-back')) {
            topPopupBack.remove();
          }
        }

        // 팝업 지우기
        topPopup.remove();

      }
    }

    // 페이지 로드 시, 쿠키 상태에 따라 팝업 보이기/숨기기 설정
    const popups = document.querySelectorAll('.wp-block-hellopanda-popup-block');
    popups.forEach(popup => {
      const key = popup.dataset.key;
      const code = popup.dataset.code;
      const cookie = enabledCookie 
                     ? _.getCookie('hellopanda-popup-' + key +'-'+ code) 
                     : _.getStorage('hellopanda-popup-' + key + '-' + code);

      /**
       * 닫았거나, 비활성화 상태라면 아예 제거 한다. ( dom 아끼기 )
       */
      if (cookie === 'closed' || !popup.classList.contains('hellopanda-blocks-popup-active')) {
        // popup.style.display = 'none'; // 쿠키가 설정된 팝업은 숨기기
        // setTimeout(() => {
          popup.remove();
        // }, 3000);
      } else {

        // console.log(_.getAnimationDelayInSeconds(popup));
        setTimeout(() => {
          
          popup.style.animationDelay = '';
          popup.setAttribute('status', 'ready');

          const controls = popup.querySelector('.hellopanda-popup-block-controls');
          const cookieButton = controls.querySelector('.wp-block-hellopanda-popup-block-cookie');
          const closeButton = controls.querySelector('.wp-block-hellopanda-popup-block-close');

          if (cookieButton) {
            cookieButton?.addEventListener('click', function(e) {
              closePopup(popup);
            });
          }
          if (closeButton) {
            closeButton?.addEventListener('click', function(e) {
              closePopupInTarget(popup);
            });
          }

          // 암막 만들기
          const boxShadow = popup.style.boxShadow;
          const delay = popup.style.animationDelay || '1s' ;
          if (boxShadow) {
            const colorRegex = /(rgba?\([^)]+\)|#[0-9a-fA-F]{3,6})/g;
            const colors = boxShadow.match(colorRegex)[0];
            if (colors) {
              popup.style.boxShadow = '';
              popup.insertAdjacentHTML(
                'afterend',
                `<div class="wp-block-hellopanda-popup-block-back" style="z-index:${Math.round(popup.style.zIndex) - 1};background-color:${colors};animation-delay:${delay};"></div>`,
              );
            }
          }

        }, _.getAnimationDelayInSeconds(popup));
      }

    });

    // esc, 외부 클릭시 팝업창을 순서대로 닫음
    if (popups.length) {
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closePopupInOrder();
          // popups.forEach(popup => {
          //   // console.log('제거함')
          //   popup.remove();
          // });
        }
      });
      document.addEventListener('click', function (event) {
        if (!event.target.closest('.wp-block-hellopanda-popup-block')) {
          closePopupInOrder();
        }
        // if (!event.target.closest('.wp-block-hellopanda-popup-block')) {
        //   const current_popup = document.querySelector('.wp-block-hellopanda-popup-block');
        //   if (current_popup) {
        //     current_popup.remove();
        //   }
        // }
      });
    }

  },
  getAnimationDelayInSeconds: function (el) {
    
    if (!el) return 0;
    const delay = window.getComputedStyle(el).animationDelay;

    // animationDelay는 "0.5s", "200ms" 등 문자열로 반환됨
    const toSeconds = (value) => {
      if (value.endsWith('ms')) {
        return parseFloat(value);
      }
      if (value.endsWith('s')) {
        return parseFloat(value) * 1000;
      }
      const num = parseFloat(value);
      return isNaN(num) ? 0 : num; // fallback if no unit
    };

    // 애니메이션이 여러 개인 경우 콤마로 구분되어 있음
    const delays = delay.split(',').map(d => toSeconds(d.trim()));
    return delays[0] || 0;

  },
  effect_link: function() {

    const links = document.querySelectorAll('.wp-block-hellopanda-effect-link, .wp-block-hellopanda-button-block');
    links.forEach(block => {
      const handleClick = (event) => {

        // 링크 자체를 물고 있다면 적용을 안하는게 맞다.
        // 외부 박스 링크와 내부 실제 버튼이 혼재하는 경우.
        if (event.target?.href) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        let url = block.dataset.linkUrl;        // data-link-url
        const vurl = block.dataset.linkVurl || '';  // data-link-vurl
        const target = block.dataset.linkTarget || '_self'; // data-link-target
        const inside = block.dataset.linkInside;  // data-link-inside

        // 주소 트릭
        if (vurl) {
          const connect_url = block.querySelector('.wp-block-hellopanda-button-connect-block')?.getAttribute('href');
          if (connect_url && url !== connect_url) {
            url = connect_url; // 바로 assign
          }
        }

        if (url) {
          if (target === '_blank') {
            window.open(url, target);
          } else {
            window.location.href = url;
          }
        } else if (inside) {
          const firstElement = block.querySelector('a');
          const firstLink = firstElement ? firstElement.getAttribute('href') : '' ;
          const firstLinkTarget = firstElement ? firstElement.getAttribute('target') : '' ;
          if (firstLink) {
            if (firstLinkTarget === '_blank') {
              window.open(firstLink, firstLinkTarget);
            } else {
              window.location.href = firstLink;
            }
          }
        }
      };
      block.addEventListener('click', handleClick);
    });

  },
  parallax_background: function () {

    const parallaxs = document.querySelectorAll('.wp-block-cover.wp-block-cover-core-parallax');

    function parallax_scroll(cover, strength, reverse, element) {

      // if ($.isDeviceMobile()) {
      //   return;
      // }

      // const rect = element.getBoundingClientRect();
      // const center = rect.top + (rect.height / 2) - (window.innerHeight / 2);
      // const maxHeight = (window.innerHeight + rect.height) / 2;
      // const percent = center / maxHeight * 100;
      // const position = (percent / 100) * rect.height * 2;
      // const lastPosition = position * (strength / 100) * -1;

      // console.log(center, `${percent}`)

      // // const height = (rect.height + (rect.height * (strength / 100) * 2) + (window.innerHeight * (strength / 100) * 2)) / 2;
      // // const height = (rect.height + (rect.height * (strength / 100) * 2 / 2) + (window.innerHeight * (strength / 100) * 2 / 2)) * .8;
      // // const height = rect.height + ((window.innerHeight - rect.height) * (strength / 100) * 2);    
      // const height = `calc(100% + ${(rect.height * 2) * (strength / 100)}px)`;
      
      // cover.style.height = height;
      // cover.style.transform = `translate(-50%, calc(-50% + ${lastPosition}px))`;

      const deviceHeight = Math.max(window.innerHeight || 0, window.screen.height || 0);

      const rect = element.getBoundingClientRect();
      const center = rect.top + (rect.height / 2) - (deviceHeight / 2);
      const maxHeight = (deviceHeight + rect.height) / 2;
      const percent = center / maxHeight * 100;
      const position = (percent / 100) * rect.height;
      const lastPosition = reverse ? 
                            position * (strength / 100) * -.5 : 
                            position * (strength / 100) * -1 ;

      // const height = (rect.height + (rect.height * (strength / 100) * 2) + (window.innerHeight * (strength / 100) * 2)) / 2;
      // const height = (rect.height + (rect.height * (strength / 100) * 2 / 2) + (window.innerHeight * (strength / 100) * 2 / 2)) * .8;
      // const height = rect.height + ((window.innerHeight - rect.height) * (strength / 100) * 2);    
      const height = `calc(${rect.height + (deviceHeight * (strength / 100))}px)`;
      window.requestAnimationFrame(function() {
        cover.style.height = height;
        cover.style.transform = reverse ? 
                                `translate(-50%, calc(-50% - ${parseInt(lastPosition)}px))` : 
                                `translate(-50%, calc(-50% + ${parseInt(lastPosition)}px))` ;
        if (rect.height < deviceHeight) {
          cover.style.maxHeight = reverse ? 
                                  `calc(${deviceHeight}px + ${(deviceHeight + rect.height)}px)` : 
                                  `calc(${deviceHeight}px + ${(deviceHeight - rect.height)}px)` ;
        }
      });

    }
    
    function handleScroll() {
      parallaxs.forEach(element => {
        const cover = element.querySelector('.wp-block-cover__image-background');
        const strength = parseInt(element.dataset.parallaxGap, 10) || 1;
        const reverse = element.dataset.parallaxReverse;

        if (!cover) {
          const newCover = document.createElement('div');
          newCover.classList.add('wp-block-cover__image-background', 'has-parallax');
          newCover.style.backgroundImage = element.style.backgroundImage;
          element.style.backgroundImage = '';
          element.appendChild(newCover);
        }

        if (cover && (strength >= 0 && strength <= 100)) {
          parallax_scroll(cover, strength, reverse, element);
          element.classList.add('wp-block-cover-core-parallax-initialized')
        }
      });
    }
    
    // 이벤트 리스너 등록 (한 번만)
    document.addEventListener('scroll', () => {
      // requestAnimationFrame을 사용하여 성능 최적화
      requestAnimationFrame(handleScroll);
    });
    
    // 초기 설정
    requestAnimationFrame(() => {
      setTimeout(() => {
        handleScroll();
      }, 1);
    });

  }
};
themeModule.init();